export default "__VITE_ASSET__B6ku2D_d__"